'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["formGuid"],
  _excluded2 = ["formGuid"];
import { DialogKeys, PanelKeys } from 'FormsUI/constants/DialogsAndPanels';
function createAction(name) {
  return `@@dialogsAndPanels/${name}`;
}
export const SHOW_DIALOG = createAction('SHOW_DIALOG');
export const CLOSE_DIALOG = createAction('CLOSE_DIALOG');
export const SHOW_PANEL = createAction('SHOW_PANEL');
export const CLOSE_PANEL = createAction('CLOSE_PANEL');
const showDialogAction = (dialogKey, _ref = {}) => {
  let {
      formGuid
    } = _ref,
    data = _objectWithoutPropertiesLoose(_ref, _excluded);
  return {
    type: SHOW_DIALOG,
    dialogKey,
    formGuid,
    data
  };
};
const closeCurrentDialogAction = () => ({
  type: CLOSE_DIALOG
});
const showPanelAction = (panelKey, _ref2 = {}) => {
  let {
      formGuid
    } = _ref2,
    data = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return {
    type: SHOW_PANEL,
    panelKey,
    formGuid,
    data
  };
};
const closeCurrentPanelAction = () => ({
  type: CLOSE_PANEL
});
export const showDialog = (dialogKey, payload) => dispatch => dispatch(showDialogAction(dialogKey, payload));
export const closeCurrentDialog = () => dispatch => dispatch(closeCurrentDialogAction());
const showPanel = (panelKey, payload) => dispatch => dispatch(showPanelAction(panelKey, payload));
export const closeCurrentPanel = () => dispatch => dispatch(closeCurrentPanelAction());
export const showPageListDialog = formGuid => dispatch => showDialog(DialogKeys.PAGE_LIST, {
  formGuid
})(dispatch);
export const showDeleteDialog = formGuid => dispatch => dispatch(showDialog(DialogKeys.DELETE_FORM, {
  formGuid
}));
export const showAssignTeamsPanel = (formGuid = '') => dispatch => dispatch(showDialog(DialogKeys.ASSIGN_TEAMS, {
  formGuid
}));
export const showCreateSupportFormDialog = () => dispatch => dispatch(showDialog(DialogKeys.CREATE_SUPPORT_FORM));
export const showTransformToTicketDialog = () => dispatch => dispatch(showDialog(DialogKeys.TRANSFORM_TO_TICKET));
export const showDisableTicketWarningDialog = () => dispatch => dispatch(showDialog(DialogKeys.DISABLE_TICKET_WARNING));
export const showExportDashboardDataDialog = () => dispatch => dispatch(showDialog(DialogKeys.EXPORT_DASHBOARD_DATA));
export const showExportComparisonToolDialog = () => dispatch => dispatch(showDialog(DialogKeys.EXPORT_COMPARISON_DATA));
export const showPropertyCreatePanel = () => dispatch => dispatch(showPanel(PanelKeys.PROPERTY_CREATE));
export const showExitIntentWithChangesDialog = (url = '') => dispatch => dispatch(showDialog(DialogKeys.EXIT_INTENT_WITH_CHANGES, {
  url
}));
export const showExitIntentWithSkipUpdateDialog = () => dispatch => dispatch(showDialog(DialogKeys.EXIT_INTENT_WITH_SKIP_UPDATE_INTEGRATIONS));
export const showExitIntentWithSkipCreateDialog = () => dispatch => dispatch(showDialog(DialogKeys.EXIT_INTENT_WITH_SKIP_CREATE_INTEGRATIONS));
export const showRemovePaymentDialog = () => dispatch => dispatch(showDialog(DialogKeys.REMOVE_PAYMENT));